import { defineTranslateKeys } from 'lib/tolgee'

import { FILES_PER_DROP_LIMIT } from '../common/documents.consts'

export const translations = defineTranslateKeys({
  modalTitle: {
    key: 'modal-documents-title',
    defaultValue: 'Fontes de dados',
  },
  filesAdded: (count: number) => ({
    key: 'modal-documents-files-added',
    parameters: { count },
    defaultValue: '{count, plural, one {# arquivo adicionado} other {# arquivos adicionados}}',
  }),
  addFilesButton: {
    key: 'modal-documents-add-files-button',
    defaultValue: 'Adicionar arquivos',
  },
  emptyStateMessage: {
    key: 'modal-documents-empty-state-message',
    parameters: {
      breakline: <p></p>,
    },
    defaultValue:
      'Adicione documentos ao seu workspace para que a Zai tenha mais <breakline></breakline> contexto da sua marca e gere respostas mais precisas.',
  },
  dropFilesMessage: {
    key: 'modal-documents-drop-files-message',
    defaultValue: 'Solte seus arquivos aqui',
  },
  errorExtensionNotSupported: {
    key: 'modal-documents-error-extension-not-supported',
    defaultValue: 'Tipo de arquivo não suportado.',
  },
  errorMaxFilesExceeded: {
    key: 'modal-documents-error-max-files-exceeded',
    parameters: { limit: FILES_PER_DROP_LIMIT },
    defaultValue: 'Você pode adicionar até {limit} arquivos por vez.',
  },
  emptySearchResultsMessage: {
    key: 'modal-documents-empty-search-results-message',
    defaultValue: 'Nenhum arquivo encontrado para sua busca.',
  },
})
